










import { Component, Vue, Prop} from 'vue-property-decorator'
import { getMessageById, checkNoticeCanJump } from '@/apis/home';
import {sysMessage} from './message'
@Component({
  components: {
  }
})
export default class extends Vue {
  private cardDetailMessage: any = {

  }
  // 跳转到工作表记录
  private async jump () {
    const {applicationId, worksheetId, viewId, recordId} = this.cardDetailMessage.noticeJumpConfig
    let res = await checkNoticeCanJump({applicationId, worksheetId, viewId, recordId})
    if (res.success) {
      if (res.data.canJump) {
        this.$router.push(`/${applicationId}/${worksheetId}/sheet/${viewId}/${recordId}`);
      } else {
        this.$toast.fail(res.data.message)
      }
    }
  }
  private async getDetail (id) {
    const res = await getMessageById(id)
    if (res.success) {
      let data = res.data
      if (data.type === 'SYSTEM') {
        data.message = sysMessage(data.message)
      }
      this.cardDetailMessage = data
    }
  }
  private beforeRouterUpdate (to, from, next) {
    this.getDetail(to.params.messageId)
    next()
  }
  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm) => {
      vm.getDetail(to.params.messageId)
    })
  }
}
